import { FormStateBasic } from 'informed';

import {
  removeEmptyParams,
  verifyURLParamsBwLinkAndRedirectionLink
} from '@nw/shared/utils';

import { stepTypes } from '../../constants/FormConstant';

export const isAuthenticationStep = (currentStepType: string): boolean =>
  currentStepType === stepTypes.AUTHENTICATION_STEP;

export const getSuccessSlotDateTime = (
  formValues: FormStateBasic['values']
): { slotDate: string | undefined; slotTime: string | undefined } => {
  const slotDate =
    (formValues['selectADateToBookASlot'] as string) ??
    (formValues['webinar1DateTime'] as string);
  const slotTime =
    (formValues['timeSlots'] as string) ??
    (formValues['preferredWebinarSlot'] as string);

  return { slotDate, slotTime };
};

export const handleConditionBasedRedirection = (
  condition: object[] | undefined,
  formValues: FormStateBasic['values']
): void => {
  if (!condition) {
    return;
  }

  //NOtE: values will be used in eval
  const values = formValues;
  condition.forEach((redirectionUrlDetail: object) => {
    const { redirection_condition, redirection_url } = redirectionUrlDetail as {
      redirection_condition: string;
      redirection_url: string;
    };
    if (eval(redirection_condition)) {
      const targetUrl = new URL(redirection_url);
      const validatedUrl = verifyURLParamsBwLinkAndRedirectionLink(targetUrl);
      window.location.href = removeEmptyParams(validatedUrl);
    }
  });
};
